import BiCashMultiplePromosModal from './BiCashMultiplePromosModal.f';

export default BiCashMultiplePromosModal;
